import axios from "axios";

const appUrl = window.location.origin;
const urls = ["http://localhost:3000"];

const baseUrl = urls.includes(appUrl)
  ? import.meta.env.VITE_APP_API_ENDPOINT
  : `${appUrl}/spa/`;

const apiClient = axios.create({
  baseURL: baseUrl,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-type": "application/json",
  },
});

apiClient.interceptors.response.use((res) => {
  const headers = {};
  if (res.headers?.xsrftoken) {
    headers["X-XSRF-TOKEN"] = res.headers.xsrftoken;
  }

  if (res.headers?.sessiontoken) {
    headers["Session-Token"] = res.headers.sessiontoken;
  }

  if (headers) {
    apiClient.defaults.headers.common = headers;
  }

  return res;
});

export default apiClient;
